import { businessRoute, categoryRoute, contentRoute, dashboardRoute, deliveryAgentsRoute, inventoryRoute, invoicesRoute, notificationsRoute, ordersRoute, pickupOrdersRoute, quotationRequestRoute, settingsRoute, ticketsRoute, userRolesRoute } from './shared/routes/custom.routes';
import { ContentLayoutComponent } from './shared/layout-components/layout/content-layout/content-layout.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { anonymousGuard } from './guards/anonymous.guard';
import { authGuard } from './guards/auth.guard';
import { CmsComponent } from './components/cms-components/cms.component';

const routes: Routes = [
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
  {
    path: '', loadChildren: () => import('./authentication/authentication.module').then((m) => m.AuthenticationModule),
    canActivate: [anonymousGuard]
  },
  {
    component: CmsComponent,
    path: '', loadChildren: () => import('./components/cms-components/cms.module').then((m) => m.CmsModule),
  },
  // {
  //   path: '',
  //   redirectTo: '/dashboard',
  //   pathMatch: 'full'
  // },
  // // Vertical layout
  {
    path: '',
    component: ContentLayoutComponent,
    canActivate: [authGuard],
    children: [dashboardRoute, deliveryAgentsRoute, userRolesRoute, businessRoute, inventoryRoute, ordersRoute, quotationRequestRoute, 
      pickupOrdersRoute, notificationsRoute, invoicesRoute, contentRoute, ticketsRoute, settingsRoute, categoryRoute]
    // customRoute
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
